import { Editor } from '@tiptap/react'
import { useLayoutEffect } from 'react'
import { TextEditorProps } from '../types'
import { getContentChain } from '../utils'

/**
 * Custom hook for TextEditor that implements the "save on unmount"
 * functionality. If `saveOnUnmount` is true, the `onSaveContent`
 * callback will be invoked when TextEditor is unmounted.
 */
export const useSaveOnUnmount = (
  editor: Editor | null,
  saveOnUnmount: boolean,
  onSaveContent: TextEditorProps['onSaveContent']
) => {
  useLayoutEffect(() => {
    if (!editor || !saveOnUnmount || typeof onSaveContent !== 'function') {
      return
    }

    return () => {
      if (editor && !editor.isDestroyed) {
        console.debug('TextEditor unmounting, saving...')
        onSaveContent?.(getContentChain(editor))
      }
    }
  }, [editor, saveOnUnmount, onSaveContent])
}
